import {Component, Inject} from '@angular/core';
import {Router} from '@angular/router';

import {GuideService} from '../../services/guide.service';
import {MapService} from '../../services/map.service';
import {Spot, Guide, Category} from '../../core/model';
import {WindowService} from '../../services/window.service';
import {MatSidenav} from '@angular/material';

@Component({
  selector: 'spot-list',
  templateUrl: './spot-list.component.html',
  styleUrls: [
    './spot-list.component.less',
    '../../../assets/css/main.less'
  ]
})
export class SpotListComponent {

  private showSpot = 'all';
  private spots: Spot[] = [];
  private sidenav: MatSidenav;

  guide: Guide = {} as Guide;
  categories: Array<Category> = [];
  searchText = '';

  constructor(private guideService: GuideService, private router: Router, @Inject(WindowService) private _window: Window) {
    this.guideService.getActiveGuide().then(guide => {
      this.guide = guide;
      this.spots = guide.spots;
    });
    this.guideService.getCategories().then(categories => {
      this.categories = categories;
    });
  }

  ngOnInit() {

  }

  public setSideNav(sidenav: any) {
    this.sidenav = sidenav;
  }

  showAllMarker() {
    this.showSpot = 'all';
    this.router.navigate(['/']);
  }

  showMarker(spot: Spot) {
    this.showSpot = spot.name;
    this.router.navigate(['/map', spot._id]);
  }

  showDetails(spot: Spot) {
    // if width of window is less or equal to 600px than we toggle the side-nav to make room for the details.
    if (this._window.screen.width <= 600) {
      this.sidenav.toggle();
    }
    this.showSpot = spot.name;
    this.router.navigate(['/spot', spot._id]);
  }

  public getSpots(category: Category) {
    const spotsForCategory: Array<Spot> = new Array<Spot>();
    this.spots.forEach(spot => {
      if (category.name === spot.category.name) {
        if (this.spotPassesSearchText(spot)) {
          spotsForCategory.push(spot);
        }
      }
    });
    return spotsForCategory;

  }

  spotPassesSearchText(spot: Spot): boolean {

    if (this.searchText === '') {
      return true;
    } else {
      let spotString: string = spot.name.toLowerCase();
      if (spot.description != undefined) {
        spotString += ' ' + spot.description.toLowerCase();
      }
      if (spotString.includes(this.searchText.toLowerCase())) {
        return true;
      }
    }
    return false;

  }

}



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/components/spot-list/spot-list.component.ts